import {
  beverageInitialMessages,
  beverageOptMessages,
  logMeInMessage,
  messageTypes, savedMessages
} from "../BeverageConstants";

export const getMessagesInitialState = (acid, cachedMessages, beverageConsentResponded) => {
  if (acid && cachedMessages) {
    return [...cachedMessages, {
      isBot: false,
      messageType: messageTypes.Text,
      message: logMeInMessage
    }, ...savedMessages, ...(beverageConsentResponded ? [] : beverageOptMessages)];
  }

  return cachedMessages ?? beverageInitialMessages;
}